export default __webpack_public_path__ + "static/media/video_6_mucnatka.fe8c6c8d.mp4";